import React from 'react';
import Input from '../../../components/ui/Input';
import Select from '../../../components/ui/Select';
import { Checkbox } from '../../../components/ui/Checkbox';
import Icon from '../../../components/AppIcon';

const ApplicationQuestionsSection = ({ formData, handleInputChange, handleSelectChange, handleCheckboxChange, errors }) => {
  const experienceLevels = [
    { value: '0-1', label: '0-1 years' },
    { value: '1-3', label: '1-3 years' },
    { value: '3-5', label: '3-5 years' },
    { value: '5-8', label: '5-8 years' },
    { value: '8+', label: '8+ years' }
  ];

  const noticePeriods = [
    { value: 'immediate', label: 'Immediate' },
    { value: '15days', label: '15 days' },
    { value: '1month', label: '1 month' },
    { value: '2months', label: '2 months' },
    { value: '3months', label: '3 months' }
  ];

  return (
    <div className="bg-card border border-border rounded-lg p-6 mb-6">
      <div className="flex items-center gap-3 mb-6">
        <div className="flex items-center justify-center w-10 h-10 bg-primary/10 rounded-lg">
          <Icon name="MessageSquare" size={20} color="var(--color-primary)" />
        </div>
        <div>
          <h3 className="text-lg font-semibold text-foreground">Application Questions</h3>
          <p className="text-sm text-muted-foreground">Help us understand your fit for this role</p>
        </div>
      </div>
      <div className="space-y-6">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <Select
            label="Total Experience"
            options={experienceLevels}
            value={formData?.experience}
            onChange={(value) => handleSelectChange('experience', value)}
            placeholder="Select experience level"
            required
            error={errors?.experience}
          />

          <Input
            label="Current/Last CTC (₹ per annum)"
            type="text"
            name="currentCtc"
            value={formData?.currentCtc}
            onChange={handleInputChange}
            placeholder="e.g., 8,00,000"
            required
            error={errors?.currentCtc}
            description="In Indian Rupees"
          />

          <Input
            label="Expected CTC (₹ per annum)"
            type="text"
            name="expectedCtc"
            value={formData?.expectedCtc}
            onChange={handleInputChange}
            placeholder="e.g., 12,00,000"
            required
            error={errors?.expectedCtc}
            description="In Indian Rupees"
          />

          <Select
            label="Notice Period"
            options={noticePeriods}
            value={formData?.noticePeriod}
            onChange={(value) => handleSelectChange('noticePeriod', value)}
            placeholder="Select notice period"
            required
            error={errors?.noticePeriod}
          />
        </div>

        <div className="space-y-4">
          <Checkbox
            label="I am willing to relocate for this position"
            checked={formData?.willingToRelocate}
            onChange={(e) => handleCheckboxChange('willingToRelocate', e?.target?.checked)}
          />

          <Checkbox
            label="I am open to remote work opportunities"
            checked={formData?.openToRemote}
            onChange={(e) => handleCheckboxChange('openToRemote', e?.target?.checked)}
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-foreground mb-2">
            Why are you interested in this position? <span className="text-error">*</span>
          </label>
          <textarea
            name="whyInterested"
            value={formData?.whyInterested}
            onChange={handleInputChange}
            rows={4}
            className="w-full px-4 py-3 bg-background border border-input rounded-lg text-foreground placeholder:text-muted-foreground focus:outline-none focus:ring-2 focus:ring-ring focus:border-transparent transition-smooth resize-none"
            placeholder="Share your motivation and what makes you a great fit for this role..."
            required
          />
          {errors?.whyInterested && (
            <p className="text-sm text-error mt-1 flex items-center gap-1">
              <Icon name="AlertCircle" size={14} />
              {errors?.whyInterested}
            </p>
          )}
        </div>

        <div>
          <label className="block text-sm font-medium text-foreground mb-2">
            Relevant Skills & Technologies
          </label>
          <textarea
            name="relevantSkills"
            value={formData?.relevantSkills}
            onChange={handleInputChange}
            rows={3}
            className="w-full px-4 py-3 bg-background border border-input rounded-lg text-foreground placeholder:text-muted-foreground focus:outline-none focus:ring-2 focus:ring-ring focus:border-transparent transition-smooth resize-none"
            placeholder="List your key skills relevant to this position (e.g., React, Node.js, Python, AWS...)"
          />
          <p className="text-xs text-muted-foreground mt-1">Separate skills with commas</p>
        </div>
      </div>
    </div>
  );
};

export default ApplicationQuestionsSection;